import { c as _c } from "react/compiler-runtime";
import { Link, Button, type SxProps } from '@mui/material';
export const SUPPORT_EMAIL = 'support@eon.io';
function buildMailtoLink(email: string, options: {
  subject?: string;
  body?: string;
  cc?: string;
  bcc?: string;
} = {}): string {
  const params: string[] = [];
  if (options.subject) {
    params.push(`subject=${encodeURIComponent(options.subject)}`);
  }
  if (options.body) {
    params.push(`body=${encodeURIComponent(options.body)}`);
  }
  if (options.cc) {
    params.push(`cc=${encodeURIComponent(options.cc)}`);
  }
  if (options.bcc) {
    params.push(`bcc=${encodeURIComponent(options.bcc)}`);
  }
  const query = params.length > 0 ? `?${params.join('&')}` : '';
  return `mailto:${email}${query}`;
}
export const ContactSupportButton = t0 => {
  const $ = _c(9);
  const {
    subject,
    body,
    variant: t1,
    sx
  } = t0;
  const variant = t1 === undefined ? "outlined" : t1;
  let t2;
  if ($[0] !== body || $[1] !== subject) {
    t2 = buildMailtoLink(SUPPORT_EMAIL, {
      subject,
      body
    });
    $[0] = body;
    $[1] = subject;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const href = t2;
  let t3;
  if ($[3] !== sx || $[4] !== variant) {
    t3 = <Button variant={variant} sx={sx}>Contact Support</Button>;
    $[3] = sx;
    $[4] = variant;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== href || $[7] !== t3) {
    t4 = <Link href={href} underline="always">{t3}</Link>;
    $[6] = href;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export const ContactSupportLink = t0 => {
  const $ = _c(4);
  const {
    color,
    text
  } = t0;
  const t1 = color || "error";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = buildMailtoLink(SUPPORT_EMAIL);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = text || "email Eon support";
  let t4;
  if ($[1] !== t1 || $[2] !== t3) {
    t4 = <Link color={t1} href={t2} underline="always">{t3}</Link>;
    $[1] = t1;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};